module.exports = __webpack_public_path__ + "static/media/mastercard.e367f808.png";